export default "__VITE_ASSET__CUAaFp1___"